import {
  deleteWebhookByIdAndUserId,
  getWebhooksByUserId,
  postWebhookByUserId,
  putUpdateWebhookByIdAndUserId,
  Webhook,
} from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';

import { WebhookMap } from '@/components/modules/Webhooks/maps/webhook.map';
import { AddOrEditWebhookFormType } from '@/components/modules/Webhooks/schemas/AddOrEditWebhookForm.schema';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const useWebhooks = (userId: string) => {
  const { request, loading } = useRequest();
  const { data, loading: loadingWebhooks, revalidate } = useCache(getWebhooksByUserId, { userId });

  const webhooks = useMemo<Webhook[] | undefined>(
    () => data?.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)),
    [data],
  );

  const createWebhook = async (formValues: AddOrEditWebhookFormType) => {
    await request(postWebhookByUserId, { userId, ...WebhookMap.toWebhookRequest(formValues) });
    revalidate();
  };

  const editWebhook = async (formValues: AddOrEditWebhookFormType, webhookId: string) => {
    await request(putUpdateWebhookByIdAndUserId, { userId, webhookId, ...WebhookMap.toWebhookRequest(formValues) });
    revalidate();
  };

  const deleteWebhook = async (webhookId: string) => {
    await request(deleteWebhookByIdAndUserId, { userId, webhookId });
    revalidate();
  };

  return {
    webhooks,
    loadingWebhooks,
    createWebhook,
    editWebhook,
    deleteWebhook,
    loading,
  };
};
